import Backbone from "backbone";
import CamPhotoModel from "./CamPhotoModel";


let CamPhotoCollection = Backbone.Collection.extend("CamPhotoCollection", {
    model: CamPhotoModel
});

export default CamPhotoCollection;
